import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { authRoutes, publicRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import Login from "../auth/login";
import { Helmet } from "react-helmet-async";
import Error404 from "../pages/error/error-404";
import { useSelector } from "react-redux";
import { RootState } from "../../core/data/redux/store";

const ALLRoutes: React.FC = () => {
  const location = useLocation();
  const permissions = useSelector(
    (state: RootState) => state.permission.permissions
  );

  // Find the current route in either public or auth routes
  const currentRoute =
    publicRoutes.find((route) => route.path === location.pathname) ||
    authRoutes.find((route) => route.path === location.pathname);

  // Construct the full title
  const fullTitle = currentRoute?.title
    ? `${currentRoute.title} | ZARCRM - Powered By: Zayonix Systems`
    : "ZARCRM - Powered By: Zayonix Systems";

  useEffect(() => {
    document.title = fullTitle;
  }, [fullTitle]);

  return (
    <>
      <Helmet>
        <title>{fullTitle}</title>
      </Helmet>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          element={
            publicRoutes?.some((route) =>
              permissions?.some(
                (module: string) =>
                  module?.toLowerCase() === route?.title?.toLowerCase()
              )
            ) ? (
              <Feature />
            ) : (
              <Navigate to="/no-permission" />
            )
          }
        >
          {publicRoutes
            ?.filter((route) =>
              permissions?.some(
                (module: string) =>
                  module?.toLowerCase() === route?.title?.toLowerCase()
              )
            )
            .map((route, idx) => (
              <Route path={route.path} element={route.element} key={idx} />
            ))}
        </Route>
        <Route element={<AuthFeature />}>
          {authRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
        {/* Catch-all for undefined routes */}
        <Route path="*" element={<Error404 />} />
      </Routes>
    </>
  );
};

export default ALLRoutes;
